jQuery($ => {
  // Shortcode Buttons
	// Add class to parent
	if ($('.shortcode-btn').length) {
		$('.shortcode-btn').parent().addClass('shortcode-btn-wrap');
	}
});